import { useState } from 'react';
import { Link } from 'react-router';
import { Button } from '@/components/Button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/shadcn-ui/card';
import { Input } from '@/components/shadcn-ui/input';
import { Label } from '@/components/shadcn-ui/label';
import { auth } from '@/services/auth';
import { logError } from '@/services/logger';

export function ForgotPasswordScene() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  function handleSubmit(e: React.SubmitEvent<HTMLFormElement>): void {
    e.preventDefault();
    setIsLoading(true);

    const redirectTo = new URL(
      '/reset-password',
      window.location.origin,
    ).toString();

    void (async () => {
      try {
        await auth.resetPassword(email, redirectTo);
        setIsSubmitted(true);
      } catch (error) {
        logError(error, 'Failed to reset password');
        setIsSubmitted(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }

  return (
    <div className="container flex h-screen w-screen flex-col items-center justify-center">
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
        <Card>
          <CardHeader>
            <CardTitle>Forgot Password</CardTitle>
            <CardDescription>
              Enter your email address and we'll send you a password reset link
            </CardDescription>
          </CardHeader>
          <CardContent>
            {isSubmitted ? (
              <div>
                <div className="relative rounded border border-green-400 bg-green-100 px-4 py-3 text-green-700">
                  Check your email for a password reset link
                </div>
                <div className="mt-4 text-center text-sm">
                  <Link to="/sign-in" className="underline underline-offset-4">
                    Back to sign in
                  </Link>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col gap-6">
                  <div className="grid gap-3">
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      type="email"
                      placeholder="m@example.com"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                    />
                  </div>
                  <div className="flex flex-col gap-3">
                    <Button
                      type="submit"
                      className="w-full"
                      disabled={isLoading}
                    >
                      {isLoading ? 'Sending...' : 'Send Reset Link'}
                    </Button>
                  </div>
                </div>
                <div className="mt-4 text-center text-sm">
                  Remember your password?{' '}
                  <Link to="/sign-in" className="underline underline-offset-4">
                    Sign in
                  </Link>
                </div>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
